import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root'
})
export class Adb2cAuthService {

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService
  ) { }

  /**
   * Get auth token from authorization code
   * @param code : authorization code
   * @return Object Resultset
   */
  getAuthTokenFromCode(code: string): Observable<any> {
    const url = this.envService.apiUrl + 'auth/token';
    
    // Create JSON payload to match the curl command structure
    const requestBody = {
      code: code
    };
    
    // Set headers for JSON content
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    return this.http.post<any>(url, requestBody, { headers, withCredentials: true }).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Get access and refresh tokens using refresh token
   * @param refreshToken : refresh token string
   * @return Object Result set
   */
  getAccessTokenUsingRefreshToken(refreshToken: string): Observable<any> {
    const url = this.envService.apiUrl + 'auth/refresh-token';
    const params = {
      refreshToken: refreshToken
    };
    return this.http.post<any>(url, params).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Get magic link token from authorization code
   * @param code : authorization code from magic link flow
   * @return Object Resultset
   */
  getMagicLinkTokenFromCode(code: string): Observable<any> {
    const url = this.envService.apiUrl + 'auth/magic-link-token';
    
    // Create JSON payload to match the curl command structure
    const requestBody = {
      code: code
    };
    
    // Set headers for JSON content
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    return this.http.post<any>(url, requestBody, { headers, withCredentials: true }).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
